<template>
  <v-card style="border-radius: 10px">
    <v-card-title>Your Billing History</v-card-title>
    <v-card-text v-if="billingHistory.length === 0"
      >No history to show.</v-card-text
    >
    <v-simple-table v-else fixed-header height="300px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Date</th>
            <th class="text-left">Type</th>
            <th class="text-left">Plan</th>
            <th class="text-left">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in billingHistory" :key="item.id">
            <td>{{ $moment(item.dateCreated).format("YYYY-MM-DD HH:mm") }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.plan }}</td>
            <td>${{ parseInt(item.amount) / 100 }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["billingHistory"]),
  },
  methods: {
    ...mapActions(["listBillingHistory"]),
  },
  created() {
    this.listBillingHistory();
  },
};
</script>